import Link from 'next/link'
import { Accordion } from '@corratech/pylot-ui'
import s from './faqsection.module.scss'
import React from 'react'
import cn from 'classnames'

type faqConfiguration = {
    heading?: string
    buttontext?: string
    buttonlink?: string
}
type WidgetConfiguration = {
    widgetConfiguration?: faqConfiguration
    childrens?: FAQAccordionItem[]
}
type RenderProps = {
    isOpen: boolean
}
type FAQAccordionItem = {
    id: string
    Title: (props: RenderProps) => React.ReactElement
    Content: (props: RenderProps) => React.ReactElement
}

const FaqWidgetGroup = (props: WidgetConfiguration) => {
    const { widgetConfiguration } = props
    const { buttonlink, heading, buttontext } = widgetConfiguration ?? {}

    return (
        <div className={s['faq_category-main']}>
            <div className={s['faq_category']}>
                <h1 className={s['faq_category-heading']}>{heading}</h1>
                <Accordion
                    className={cn('faq_section_div')}
                    contents={props.childrens ?? []}
                />
                {buttonlink && buttontext && (
                    <Link href={buttonlink} passHref>
                        <a className={s['faq_button']}>{buttontext}</a>
                    </Link>
                )}
            </div>
        </div>
    )
}

export default FaqWidgetGroup
